var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import { FlexGrid } from '@honeycomb/ui-core';
import { useHotelPricingPills } from '../utils/useHotelPricingPills';
import { HotelMobileDiscountPill } from '../HotelMobileDiscountPill/HotelMobileDiscountPill';
import { HotelDepositPill } from '../HotelDepositPill/HotelDepositPill';
import { HotelPayMonthlyPill } from '../HotelPayMonthlyPill/HotePayMonthlyPill';
/**
 * Render the relevant hotel pricing pills in a grid.
 */
export function HotelPricingPills(_a) {
    var { pricingSummary, roomIndex, boardIndex, suppressTypes, chipProps } = _a, other = __rest(_a, ["pricingSummary", "roomIndex", "boardIndex", "suppressTypes", "chipProps"]);
    const pills = [];
    const validTypes = useHotelPricingPills(pricingSummary);
    // Mobile discount
    if (validTypes.mobileDiscount && !(suppressTypes === null || suppressTypes === void 0 ? void 0 : suppressTypes.mobileDiscount)) {
        pills.push(React.createElement(HotelMobileDiscountPill, { chipProps: Object.assign({ size: 'xs' }, chipProps) }));
    }
    // Deposit
    if (validTypes.deposit && !(suppressTypes === null || suppressTypes === void 0 ? void 0 : suppressTypes.deposit) && pricingSummary.depositFormatted) {
        pills.push(React.createElement(HotelDepositPill, { chipProps: Object.assign({ size: 'xs' }, chipProps), depositFormatted: pricingSummary.depositFormatted || '' }));
    }
    // Pay monthly
    if (validTypes.payMonthly && !(suppressTypes === null || suppressTypes === void 0 ? void 0 : suppressTypes.payMonthly) && pricingSummary.monthlyInstalment) {
        pills.push(React.createElement(HotelPayMonthlyPill, { chipProps: Object.assign({ size: 'xs' }, chipProps), monthlyInstalment: pricingSummary.monthlyInstalment }));
    }
    if (pills.length > 0) {
        return (React.createElement(FlexGrid, Object.assign({ container: true, flexWrap: "wrap", spacing: 2 }, other), pills.map((pill, index) => (React.createElement(FlexGrid, { key: `pill-${index.toString()}` }, pill)))));
    }
    return null;
}
